'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = function bindActions() {
  $(window).resize(_handlers.fixSidebar);
  $(document).on('click', '[data-scroll-to]', _handlers.scrollTo);
  $(document).on('click', '.js-smooth-scroll', function (_ref) {
    var self = _ref.currentTarget,
        event = (0, _objectWithoutProperties3.default)(_ref, ['currentTarget']);

    // event.preventDefault();
    (0, _handlers.handleScroll)('.' + self.dataset.target);
  });
};
exports.bindActions = bindActions;